export const GENERATED_QUESTION_TYPES = {
  MULTIPLE_CHOICE: 'Questions::MultipleChoice',
  MULTIPLE_SELECT: 'Questions::MultipleSelect',
  FREE_RESPONSE: 'Questions::FreeResponse',
};

export const GENERATED_QUESTION_OPTIONS = {
  QUESTION_AND_ANSWERS: 'questions_with_answers',
  ANSWERS_ONLY: 'answers_only',
};

export const questionTypeChoices = [
  {
    text: t('lessons.editor.element_assistant.question_types.multiple_choice'),
    value: GENERATED_QUESTION_TYPES.MULTIPLE_CHOICE,
  },
  {
    text: t('lessons.editor.element_assistant.question_types.multiple_select'),
    value: GENERATED_QUESTION_TYPES.MULTIPLE_SELECT,
  },
  {
    text: t('lessons.editor.element_assistant.question_types.free_response'),
    value: GENERATED_QUESTION_TYPES.FREE_RESPONSE,
  },
];

export const questionOptionChoices = [
  {
    text: t(
      'lessons.editor.element_assistant.question_options.question_and_answers',
    ),
    value: GENERATED_QUESTION_OPTIONS.QUESTION_AND_ANSWERS,
  },
  {
    text: t('lessons.editor.element_assistant.question_options.answers_only'),
    value: GENERATED_QUESTION_OPTIONS.ANSWERS_ONLY,
  },
];
